import { Component, inject } from "@angular/core";
import { Router, RouterOutlet } from "@angular/router";
import { NavbarComponent } from "./core/layout/navbar/navbar.component";
import { FooterComponent } from "./core/layout/footer/footer.component";
import { StorageService } from "./core/services/storage.service";
import { ToastModule } from "primeng/toast";


@Component({
  selector: "app-root",
  imports: [
    RouterOutlet,
    NavbarComponent ,
    FooterComponent ,
    ToastModule
    ],
  templateUrl: "./app.component.html",
  styleUrl: "./app.component.css",
})
export class AppComponent {
  title = "Angular Template - website";
  private _storageService = inject(StorageService);
  private _router = inject(Router);

  constructor(){
    const expireAtStr = this._storageService.getLocalStorageValue('expireAt');
    const expireAt = expireAtStr ? Number(expireAtStr) : null;
  
  if (expireAt && Date.now() > expireAt) {
    // expired token
    this._storageService.removeFromLocalStorage('token');
    this._storageService.removeFromLocalStorage('userData');
    this._storageService.removeFromLocalStorage('expireAt');
    this._storageService.setLocalStorageValue('rememberMe', 'false');
    this._router.navigate(['/']);
  }
  }
  
  
 
}
